<a
  *ngIf="
    stepper.pasos[0].url !== 'pago' &&
    (this.venta.carritoValue.entradas.length > 0 ||
      this.venta.carritoOrigenValue.reservaAgrupada === '1' ||
      stepper.getUrlVentaSlice() === 'amigos-thyssen')
  "
  class="SiguienteButton"
  (click)="avanzar()"
  title="Siguiente"
  >{{ 'SIGUIENTE' | translate }}</a
>
